const AUTH_BASE = '/Auth';

export const AUTH_ENDPOINTS = {
  LOGIN: `${AUTH_BASE}/login`,
  LOGOUT: `${AUTH_BASE}/Logout`,
  STATUS: `${AUTH_BASE}/status`,
  USER_INFO: `${AUTH_BASE}/user`,
  CONFIGURATION: `${AUTH_BASE}/configuration`,
  FORGOT_PASSWORD: `${AUTH_BASE}/passwordForgot`,
  VERIFY_PASSWORD_RESET: `${AUTH_BASE}/passwordResetVerify`,
  RESET_PASSWORD: `${AUTH_BASE}/passwordReset`,
  TWO_FACTOR_VERIFY: `${AUTH_BASE}/twoFactorVerify`
} as const;
